import axios from 'axios';

// Create axios instance with interceptor for JWT token
const createAuthInterceptor = () => {
  axios.interceptors.request.use(
    (config) => {
      // Add JWT token to Authorization header for admin requests
      if (config.url && config.url.includes('/admin/')) {
        const token = localStorage.getItem('adminToken');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor for handling 401 errors
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // Token expired or invalid, redirect to login
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminAuth');
        if (window.location.pathname.startsWith('/admin')) {
          window.location.href = '/admin';
        }
      }
      return Promise.reject(error);
    }
  );
};

export default createAuthInterceptor;
